import {useHttp} from "./http.hook";
import {ISimulateOrder, IStrategyPositions, IToOrder, ITrade, OpenedPositions} from "../shared/types";
import {CountryExchange} from "../shared/countryExchange";

interface IDataSaveOpenedPositions {
    message: string,
}

interface IDataSendSignal {
    message: string,
}

interface IDataGetAll {
    message: string,
    info: IStrategyPositions[]
}

interface IDataGetAllFromAdvisors {
    message: string,
    info: typeof OpenedPositions
}

export const usePositions = () => {

    const {loading, request, error, clearError} = useHttp()

    //сохранение данных по открытым позициям для одной выбранной стратегии
    const saveOpenedPositions = async (country: CountryExchange, strategy: string, positions: string) => {
        try {
            const data: IDataSaveOpenedPositions = await request('/api/positions/save-one-strategy', 'POST', {
                country: country,
                strategy: strategy,
                positions: positions
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //удаление данных по открытым позициям для одной выбранной стратегии если закрыта последняя сделка по стратегии
    const removeOpenedPositions = async (country: CountryExchange, strategy: string) => {
        try {
            const data: IDataSaveOpenedPositions = await request('/api/positions/remove-one-strategy', 'POST', {
                country: country,
                strategy: strategy
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //отправка сигнала о сделке подписчикам в мой телеграм канал
    const sendSignalToChannel = async (order: IToOrder) => {
        try {
            const data: IDataSendSignal = await request('/api/positions/send-signal', 'POST', {
                order: order,
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //отправка сигнала о сделке подписчикам в мой телеграм канал
    const sendSignalToFreeChannel = async (order: IToOrder) => {
        try {
            const data: IDataSendSignal = await request('/api/positions/send-free-signal', 'POST', {
                order: order,
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //отправка сигнала на сервер для записи демо-видео
    const sendSignalForVideo = async (order: ISimulateOrder) => {
        try {
            const data: IDataSendSignal = await request('/api/positions/send-signal-for-video', 'POST', {
                order: order,
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //отправка полного трейда на сервер для записи демо-видео
    const sendTradeForVideo = async (trade: ITrade) => {
        try {
            const data: IDataSendSignal = await request('/api/positions/send-trade-for-video', 'POST', {
                trade: trade,
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //получение всех открытых позиций по всем стратегиям из БД
    const getAllPositions = async (country: CountryExchange) => {
        try {
            const data: IDataGetAll = await request('/api/positions', 'POST', {
                country: country
            })
            return data
        } catch (e) {
            throw e
        }
    }

    //получение всех открытых позиций по всем стратегиям из скрипта советника
    const getAllPositionsFromAdvisors = async () => {
        try {
            const data: IDataGetAllFromAdvisors = await request('/api/positions/get-from-advisors', 'POST', {})
            return data
        } catch (e) {
            throw e
        }
    }

    return {
        loading,
        saveOpenedPositions,
        removeOpenedPositions,
        sendSignalToChannel,
        sendSignalToFreeChannel,
        sendSignalForVideo,
        sendTradeForVideo,
        getAllPositions,
        getAllPositionsFromAdvisors,
        error,
        clearError
    }
}